import {Observable} from "rxjs";
import {ElementState} from "@app/core/element/domain/element-state";

export abstract class GetElementsStateTypologiesWebService {
  abstract execute(): Observable<ElementState[]>;
}
